import type { Dashboard } from './types';

export const dashboard: Dashboard = {
  kpis: [
    { key: "kpiActiveCases", value: "47", unit: "cases", delta: +12, tone: "blue", icon: "bi-folder2-open" },
    { key: "kpiArrests", value: "63", unit: "persons", delta: +8, tone: "blue", icon: "bi-person-vcard" },
    { key: "kpiSeizure", value: "4.82", unit: "kg", delta: +31, tone: "yellow", icon: "bi-capsule" },
    { key: "kpiPending", value: "14", unit: "cases", delta: -3, tone: "red", icon: "bi-hourglass-split" },
  ],
  trend: [
    { m: "01", cases: 22, arrests: 14 },
    { m: "02", cases: 28, arrests: 19 },
    { m: "03", cases: 35, arrests: 26 },
    { m: "04", cases: 31, arrests: 22 },
    { m: "05", cases: 42, arrests: 30 },
    { m: "06", cases: 38, arrests: 28 },
  ],
  byType: [
    { id: "meth", name: "Метамфетамин", nameKo: "메스암페타민", g: 1840, color: "#0054A6" },
    { id: "cannabis", name: "Каннабис", nameKo: "대마", g: 1260, color: "#1B6FBE" },
    { id: "mdma", name: "MDMA", nameKo: "MDMA", g: 740, color: "#5B8BC4" },
    { id: "ketamine", name: "Кетамин", nameKo: "케타민", g: 520, color: "#9CC0E4" },
    { id: "heroin", name: "Героин", nameKo: "헤로인", g: 460, color: "#C3D6EC" },
  ],
  status: [
    { key: "statusOngoing", value: 47, color: "#0054A6" },
    { key: "statusProsecuted", value: 38, color: "#FFCB05" },
    { key: "statusClosed", value: 71, color: "#C3CBD5" },
  ],
  regions: [
    { ko: "바양주르흐구", mn: "Баянзүрх", value: 34 },
    { ko: "송기노하이르항구", mn: "Сонгинохайрхан", value: 27 },
    { ko: "한울구", mn: "Хан-Уул", value: 21 },
    { ko: "칭겔테이구", mn: "Чингэлтэй", value: 16 },
    { ko: "바양골구", mn: "Баянгол", value: 14 },
    { ko: "지방 (다르항·에르데네트 등)", mn: "Орон нутаг", value: 19 },
  ],
  recent: [
    { no: "ХД-2026-0142", ko: "바양주르흐 메스암페타민 유통 조직", mn: "Баянзүрх метамфетамин түгээлт", date: "2026-06-08", status: "stAnalysis", lead: "Б.Ганзориг" },
    { no: "ХД-2026-0140", ko: "SNS 대마 판매 사건", mn: "Сошиал сүлжээгээр каннабис худалдсан", date: "2026-06-05", status: "stInStorage", lead: "Д.Энхжаргал" },
    { no: "ХД-2026-0137", ko: "자민우드 국경 밀반입", mn: "Замын-Үүд хилийн хууль бус нэвтрүүлэлт", date: "2026-05-29", status: "stAnalysis", lead: "С.Мөнхбат" },
    { no: "ХД-2026-0129", ko: "케타민 클럽 유통", mn: "Клубын кетамин түгээлт", date: "2026-05-21", status: "stDisposalReq", lead: "Н.Болормаа" },
    { no: "ХД-2026-0118", ko: "MDMA 정제 다량 압수", mn: "MDMA шахмал бөөнөөр хураасан", date: "2026-05-12", status: "stInStorage", lead: "Д.Энхжаргал" },
  ],
  alerts: [
    { icon: "bi-hourglass-split", ko: "감정 의뢰 후 14일 경과 — ХС-2026-0031", mn: "Шинжилгээний хүсэлтээс хойш 14 хоног өнгөрсөн — ХС-2026-0031", tone: "warning" },
    { icon: "bi-person-x", ko: "지명수배 대상 미검거 — Г.Сараннэмэх", mn: "Эрэн сурвалжлагдаж буй этгээд олдоогүй — Г.Сараннэмэх", tone: "danger" },
    { icon: "bi-trash3", ko: "폐기 승인 대기 증거물 3건", mn: "Устгал батлуулах эд мөрийн баримт 3 ширхэг", tone: "warning" },
  ],
};
